import { Link } from "react-router-dom";
import type { ReactNode } from "react";

const stats = [
  { value: "1280+", label: "已收录高校", icon: "ri-building-2-line" },
  { value: "3400+", label: "每日新增帖子", icon: "ri-chat-new-line" },
  { value: "96", label: "活跃讨论区", icon: "ri-discuss-line" },
  { value: "20", label: "每日精选话题", icon: "ri-star-smile-line" },
];

const feedUpdates = [
  "江城大学 · 图书馆占座条例执行后续更新",
  "明湖理工 · 宿舍公约模板被六个宿舍采用",
  "云麓师范 · 表白墙新增投稿规范公告",
  "星洲学院 · 自习室座位热力图第二版发布",
  "岭南海洋 · 社团招新报名人次同比上涨 9%",
  "白鹭财经 · 秋招时间线整理帖破万阅读",
  "南岭大学 · 保研复议通道说明已置顶",
  "星洲学院 · 快递站错峰取件指南更新",
];

export default function CommunityStrip(): ReactNode {
  return (
    <section aria-labelledby="community-title" className="w-full">
      <div className="w-full bg-secondary-500 py-14 md:py-20">
        <div className="mx-auto w-full px-4 md:px-8">
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <h2
                id="community-title"
                className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-[32px]"
              >
                每天有成千上万条讨论在这里发生
              </h2>
              <p className="mt-2.5 max-w-xl text-sm leading-relaxed text-foreground-800 md:text-[15px]">
                讨论区按学校与主题双维度组织，无论你来自哪一所学校，都能找到正在更新的同校现场。
              </p>
            </div>
            <Link
              to="/topics"
              className="inline-flex w-fit shrink-0 items-center gap-2 rounded-md bg-foreground-950 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 whitespace-nowrap"
            >
              <i className="ri-compass-3-line text-base"></i>
              进入讨论区
            </Link>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-6 lg:grid-cols-4">
            {stats.map((item) => (
              <div
                key={item.label}
                className="flex items-center gap-3.5 rounded-lg bg-foreground-950/10 p-4 md:p-5"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <div>
                  <dd className="font-heading text-xl font-black text-foreground-950 md:text-2xl">
                    {item.value}
                  </dd>
                  <dt className="text-xs text-foreground-800 md:text-sm">{item.label}</dt>
                </div>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="w-full overflow-hidden bg-foreground-950 py-3.5">
        <div className="flex w-max animate-marquee">
          {[0, 1].map((dup) => (
            <ul key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1}>
              {feedUpdates.map((text) => (
                <li
                  key={`${dup}-${text}`}
                  className="flex items-center gap-2 whitespace-nowrap px-6 text-sm text-background-200"
                >
                  <span className="flex h-4 w-4 items-center justify-center text-accent-400">
                    <i className="ri-broadcast-line"></i>
                  </span>
                  {text}
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </section>
  );
}